/**
 * Line-level field labels in en / fr / es for `./ProductLineItems.tsx`. `<COMPANY>` in `toolTip`
 * is replaced with the brand from `NEXT_PUBLIC_COMPANY`. `leadTime` is not read by any file.
 */
import { LanguageContent } from "@ryerson/frontend.common";

/** Line-level field labels for one language. */
export interface ProductLineItemsContent {
	customerReferenceNo: string;
	lineItemNotes: string;
	lineLevelPO: string;
	domesticRequired: string;
	leadTime: string;
	addInfo: string;
	toolTip: string;
	inventoryDetails: string;
}

/** Line-level field labels per language. */
export const content: LanguageContent<ProductLineItemsContent> = {
	en: {
		customerReferenceNo: "Customer Reference #",
		lineItemNotes: "Line Item Notes",
		lineLevelPO: "Line Level PO",
		domesticRequired: "Domestic Requested",
		leadTime: "Lead Time",
		addInfo: "add this info in checkout",
		toolTip:
			"If you need your products sourced from a specific country, please check the domestic requested box and a <COMPANY> representative will follow up with you to complete your order.",
		inventoryDetails: "Batch Details",
	},
	fr: {
		leadTime: "Délai de mise en œuvre",
		customerReferenceNo: "Référence client #",
		lineItemNotes: "Remarques sur les éléments de campagne",
		domesticRequired: "Domestique Demandée",
		lineLevelPO: "Niveau ligne PO",
		addInfo: "ajouter cette information à la caisse",
		toolTip:
			"Si vous avez besoin que vos produits proviennent d'un pays spécifique, veuillez cocher la case nationale demandée et un représentant de <COMPANY> vous contactera pour compléter votre commande.",
		inventoryDetails: "Détails du Lot",
	},
	es: {
		leadTime: "Tiempo de espera",
		customerReferenceNo: "Referencia de cliente #",
		lineItemNotes: "Notas de elementos de línea",
		lineLevelPO: "Nivel de línea PO",
		domesticRequired: "Doméstico Solicitada",
		addInfo: "agregar esta información en el pago",
		toolTip:
			"Si necesita que sus productos provengan de un país específico, marque la casilla nacional solicitada y un representante de <COMPANY> se comunicará con usted para completar su pedido.",
		inventoryDetails: "Détails del Lote",
	},
};
